import { HttpClient, HttpErrorResponse, HttpEvent, HttpHeaders, HttpResponse } from "@angular/common/http";
// import "rxjs/add/observable/throw";
// import "rxjs/add/operator/catch";
// import "rxjs/add/operator/map";
import { Observable, catchError, map, throwError } from "rxjs";
import { } from "rxjs";
import { environment } from "../../environments/environment";
import { saveAs } from "file-saver";

export abstract class HttpService {
	constructor(public endpoint: string, public http: HttpClient) { }

	// private toApiUrl(path: string) {
	// 	let url = this.endpoint + path;
	// 	url = url.replace("//", "/");
	// 	if (url.endsWith("/")) {
	// 		// Remove the "/" at the end
	// 		url = url.slice(0, -1);
	// 	}
	// 	console.log("API CALL TO URL = " + (environment.API_URL + url));
	// 	console.log(environment.API_URL)
	// 	return environment.API_URL + url;
	// }

	private toApiUrl(path: string) {
		let url = this.endpoint + path;
		url = url.replace("//", "/");
		if (url.endsWith("/")) {
					url = url.slice(0, -1);
				}
		console.log("API CALL TO URL = " + (environment.API_URL + url));
		return environment.API_URL + url;
	  }
	  
	public downloadGet(api): Promise<any> {
		return new Promise((resolve, reject) => {
		  this.http
			.get(this.toApiUrl(api), {
			  responseType: "arraybuffer",
			  withCredentials: true,
			  headers: this.getHeaders().delete("Content-Type"),
			})
			.subscribe(
			  (response) => resolve(response),
			  (err) => reject(err)
			);
		});
	  }
	
	  public downloadPost(api, data): Promise<any> {
		return new Promise((resolve, reject) => {
		  this.http
			.post(this.toApiUrl(api), data, {
			  responseType: "arraybuffer",
			  withCredentials: true,
			  headers: this.getHeaders(),
			})
			.subscribe(
			  (response) => resolve(response),
			  (err) => reject(err)
			);
		});
	  }
	
	  /** Blob download with progress events. */
	  public downloadWithProgress(api: string): Observable<HttpEvent<Blob>> {
		return this.http.get(this.toApiUrl(api), {
		  responseType: "blob",
		  withCredentials: true,
		  headers: this.getHeaders().delete("Content-Type"),
		  reportProgress: true,
		  observe: "events",
		});
	  }

	  public processDownload(response, name) {
		const blob = new Blob([response]);
		saveAs(blob, name);
	  }

	protected get(methodWtithLimits): Observable<any> {
		const option = { headers: this.getHeaders(), withCredentials: true };
		return this.http
			.get(this.toApiUrl(methodWtithLimits), option)
			.pipe(
				map((res: HttpResponse<JSON>) => res || {}),
				catchError(this.errorHandler)
			);
	}

	protected post(data, method = " ",skipLoading = false): Observable<any> {
		let headers = this.getHeaders();
		  // Add custom header only if skipLoading = true
		  if (skipLoading) {
			headers = headers.set('X-Skip-Loading', 'true');
		}
		const option = { headers: headers, withCredentials: true };
		  // Add custom header only if skipLoading = true
		  if (skipLoading) {
			headers = headers.set('X-Skip-Loading', 'true');
		}
		return this.http
			.post(this.toApiUrl(method), data, option)
			.pipe(
				map((res: HttpResponse<JSON>) => res || {}),
				catchError(this.errorHandler)
			);
	}

	// protected postGlobal(data, method = " "): Observable<any> {
	// 	const option = { headers: this.getHeaders(), withCredentials: true };
	// 	return this.http
	// 		.post(this.toApiUrlGlobal(method), data, option)
	// 		.pipe(
	// 			map((res: HttpResponse<JSON>) => res || {}),
	// 			catchError(this.errorHandler)
	// 		);
	// }

	protected put(data, method): Observable<any> {
		const option = { headers: this.getHeaders(), withCredentials: true };
		return this.http
			.put(this.toApiUrl("/" + method), data, option)
			.pipe(
				map((res: HttpResponse<JSON>) => res || {}),
				catchError(this.errorHandler)
			);
	}

	protected delete(id): Observable<any> {
		const option = { headers: this.getHeaders(), withCredentials: true };
		return this.http
			.delete(this.toApiUrl("/" + id), option)
			.pipe(
				map((res: HttpResponse<JSON>) => res || {}),
				catchError(this.errorHandler)
			);
	}

	protected deleteData(data, method): Observable<any> {
		const option = { headers: this.getHeaders(), withCredentials: true, body : data};
		return this.http
			.delete(this.toApiUrl("/" + method), option)
			.pipe(
				map((res: HttpResponse<JSON>) => res || {}),
				catchError(this.errorHandler)
			);
	}

	public abstract getHeaders(): HttpHeaders;
	// private getHeaders(): HttpHeaders {
	// 	let headers: HttpHeaders = new HttpHeaders();
	// 	headers.set('Content-Type', 'application/json');
	// 	return headers;
	// }

	private errorHandler(err: HttpErrorResponse) {
		// console.log('function side error')
		if (err.error instanceof ErrorEvent) {
			console.log("client side error --------------------------------------");
		} else {
			console.log("error ", err);
			if (err.error.error != null) {
				let error = err.error.error;
				if (error.code == 401) {
					console.log("Session token expired");
				}
				return throwError(error);
				// return Observable.throw(error);
			}
			return throwError(err.error);
			// return Observable.throw(err.error);
		}
	}

	protected uploadImage(data, method = " "): Observable<any> {
		// const option = { headers: this.getHeaders().delete('Content-Type') };
		const option = {
			headers: this.getHeaders().delete("Content-Type"),
			withCredentials: true,
		};
		return this.http
			.post(this.toApiUrl(method), data, option)
			.pipe(
				map((res: HttpResponse<JSON>) => res || {}),
				catchError(this.errorHandler)
			)

		//In case if progress is required
		// this.http.post(this.toApiUrl(method), data, {
		// 	headers: this.getHeaders().delete("Content-Type"),
		// 	reportProgress: true,
		// 	observe: 'events'
		// })
		// .subscribe(events => {
		// 	if(events.type == HttpEventType.UploadProgress) {
		// 		console.log('Upload progress: ', Math.round(events.loaded / events.total * 100) + '%');
		// 	} else if(events.type === HttpEventType.Response) {
		// 		console.log(events);
		// 	}
		// })
	}

	protected uploadPut(data, method = " "): Observable<any> {
		// const option = { headers: this.getHeaders().delete('Content-Type') };
		const option = {
			headers: this.getHeaders().delete("Content-Type"),
			withCredentials: false,
		};
		return this.http
			.put(this.toApiUrl(method), data, option)
			.pipe(
				map((res: HttpResponse<JSON>) => res || {}),
				catchError(this.errorHandler)
			)

		//In case if progress is required
		// this.http.post(this.toApiUrl(method), data, {
		// 	headers: this.getHeaders().delete("Content-Type"),
		// 	reportProgress: true,
		// 	observe: 'events'
		// })
		// .subscribe(events => {
		// 	if(events.type == HttpEventType.UploadProgress) {
		// 		console.log('Upload progress: ', Math.round(events.loaded / events.total * 100) + '%');
		// 	} else if(events.type === HttpEventType.Response) {
		// 		console.log(events);
		// 	}
		// })
	}
}
